var lastID = -1;
var subscriptions = {};
export var __TEST__ = subscriptions;

var nextID = function nextID() {
  return 'ID_' + String(++lastID);
};

var checkTopic = function checkTopic(topic) {
  if (!subscriptions[topic]) {
    subscriptions[topic] = {};
  }
};

var subscribers = function subscribers(topic) {
  checkTopic(topic);
  return subscriptions[topic];
};

export var subscribe = function subscribe(topic, callback) {
  if (typeof topic !== 'string') return undefined;
  if (typeof callback !== 'function') return undefined;
  var id = nextID();
  subscribers(topic)[id] = callback;
  callback(subscribers(topic).latest, topic);
  return id;
};

export var publish = function publish(topic, message, compareFn) {
  if (compareFn === undefined || !compareFn(subscribers(topic).latest, message)) {
    var notify = function notify(subscriber) {
      if (typeof subscriber === 'function') {
        subscriber(message, topic);
      }
    };
    subscribers(topic).latest = message;
    Object.values(subscribers(topic)).forEach(notify);
  }
};

export var unsubscribe = function unsubscribe(token) {
  var count = 0;
  var unsubscribeToken = function unsubscribeToken(subscribers) {
    if (subscribers[token]) {
      count = count + 1;
      delete subscribers[token];
    }
  };
  Object.values(subscriptions).forEach(unsubscribeToken);
  return {
    token: token,
    count: count
  };
};

var deleteTopic = function deleteTopic(topic) {
  return delete subscriptions[topic];
};
var matchesTopic = function matchesTopic(topic) {
  return function (t) {
    return t === topic;
  };
};

export var clearSubscriptions = function clearSubscriptions(topic) {
  Object.keys(subscriptions).filter(matchesTopic(topic)).forEach(deleteTopic);
};

export var clearAllSubscriptions = function clearAllSubscriptions() {
  Object.keys(subscriptions).forEach(deleteTopic);
};